'use client';

import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

const ToolsSection = () => {
  return (
    <section className="py-16 lg:py-24 bg-background">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-red-600 text-white text-xs font-bold uppercase tracking-widest px-4 py-1.5 mb-4">
            B2B Tools
          </div>
          <h2 className="font-headline font-bold text-3xl lg:text-4xl text-primary mb-4">
            Professional Project Tools
          </h2>
          <p className="text-text-secondary text-base lg:text-lg max-w-2xl mx-auto">
            Purpose-built tools for technicians, contractors, and property managers to streamline every project.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Cab Configurator Card */}
          <div className="border border-border bg-secondary group hover:border-red-600 transition-all duration-300 overflow-hidden">
            <div className="bg-red-600 h-2 w-full" />
            <div className="p-8">
              <div className="flex items-start gap-4 mb-6">
                <div className="flex-shrink-0 bg-red-600/10 border border-red-600/20 p-3">
                  <Icon name="CubeIcon" size={28} className="text-red-600" />
                </div>
                <div>
                  <h3 className="font-bold text-xl text-primary mb-1">Cab Configurator</h3>
                  <p className="text-xs text-red-600 font-semibold uppercase tracking-wide">3D Interior Design Tool</p>
                </div>
              </div>
              <p className="text-text-secondary mb-6 leading-relaxed">
                Design your elevator interior in real time. Select wall finishes, flooring, lighting, handrails, and operating panels — then generate a complete Bill of Materials with pricing instantly.
              </p>
              <ul className="space-y-2 mb-8">
                {['Choose from 8 configuration sections', 'Live visual preview updates', 'Instant BOM with pricing', 'Submit directly for a quote']?.map((item) => (
                  <li key={item} className="flex items-center gap-2 text-sm text-text-secondary">
                    <div className="w-1.5 h-1.5 bg-red-600 flex-shrink-0" />
                    {item}
                  </li>
                ))}
              </ul>
              <Link
                href="/cab-configurator"
                className="inline-flex items-center gap-2 bg-red-600 text-white px-6 py-3 font-bold text-sm tracking-wide hover:bg-red-700 transition-colors"
              >
                Launch Configurator
                <Icon name="ArrowRightIcon" size={16} />
              </Link>
            </div>
          </div>

          {/* Project Specs Card */}
          <div className="border border-border bg-secondary group hover:border-red-600 transition-all duration-300 overflow-hidden">
            <div className="bg-black h-2 w-full" />
            <div className="p-8">
              <div className="flex items-start gap-4 mb-6">
                <div className="flex-shrink-0 bg-gray-900/10 border border-gray-900/20 p-3">
                  <Icon name="DocumentTextIcon" size={28} className="text-gray-900" />
                </div>
                <div>
                  <h3 className="font-bold text-xl text-primary mb-1">Project Specifications</h3>
                  <p className="text-xs text-gray-600 font-semibold uppercase tracking-wide">Engineering Spec Form</p>
                </div>
              </div>
              <p className="text-text-secondary mb-6 leading-relaxed">
                Submit complete project specifications for custom orders. Include hoistway dimensions, capacity requirements, travel distance, and code compliance details — all in one structured form.
              </p>
              <ul className="space-y-2 mb-8">
                {['Hoistway & pit dimensions', 'Capacity & travel specs', 'Code compliance fields', 'Attach drawings & schematics']?.map((item) => (
                  <li key={item} className="flex items-center gap-2 text-sm text-text-secondary">
                    <div className="w-1.5 h-1.5 bg-gray-900 flex-shrink-0" />
                    {item}
                  </li>
                ))}
              </ul>
              <Link
                href="/project-specification-form"
                className="inline-flex items-center gap-2 bg-black text-white px-6 py-3 font-bold text-sm tracking-wide hover:bg-gray-800 transition-colors"
              >
                Start Spec Form
                <Icon name="ArrowRightIcon" size={16} />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ToolsSection;
